import axios from "axios";
import apiConfig from "../../../config/apiConfig";

const BASE_URL = apiConfig.BASE_URL
export const LOGIN_URL = BASE_URL+"api/panel/login";
export const REGISTER_URL = BASE_URL+"api/panel/register";
export const REGISTER_VERIFYـPHONE = BASE_URL+"api/panel/phone/verify/check";
export const REQUESTـPHONE_CODE = BASE_URL+"api/panel/phone/send";
export const REQUEST_PASSWORD_URL = BASE_URL+"api/panel/forgot/get";
export const REQUEST_EMAIL_CHANGE_PASSWORD_URL = BASE_URL+"api/panel/forgot/change";
export const REQUEST_VERIFY_EMAIL = BASE_URL+"api/panel/email/verify/get";

export const ME_URL = BASE_URL+"api/panel/me";

export async function login(phone, password,lang) {
  return axios.post(LOGIN_URL, {phone, password,lang});
}

export function register(phone, name, username, password,lang) {
  return axios.post(REGISTER_URL, { phone, name, username, password,lang });
}

export function requestPhoneCode(phone) {
  return axios.post(REQUESTـPHONE_CODE, { phone });
}

export function verifyPhone(phone, random) {
  return axios.post(REGISTER_VERIFYـPHONE, { phone, random });
}

export function resetPassword(email,lang) {
  return axios.post(REQUEST_PASSWORD_URL, { email,lang });
}

export function requestVerifyEmail(email,lang) {
  return axios.post(REQUEST_VERIFY_EMAIL, { email,lang });
}

export function emailChangePassword(e,r,password) {
  return axios.post(`${REQUEST_EMAIL_CHANGE_PASSWORD_URL}/${e}/${r}`, { password });
}

export function getUserByToken() {
  // Authorization head should be fulfilled in interceptor.
  return axios.get(ME_URL);
}
